import Swal from "./swal";

// Top-right auto-dismissing toast for "action completed" feedback; confirmations still use a centered modal.
const baseToast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toastEl) => {
    toastEl.addEventListener("mouseenter", Swal.stopTimer);
    toastEl.addEventListener("mouseleave", Swal.resumeTimer);

    // Fix z-index so the toast renders above an open MUI Dialog (1300 > swal2's ~1060).
    const container = document.querySelector(".swal2-container");
    if (container) container.style.zIndex = "9999";
  },
});

export const showSuccessToast = (message) => baseToast.fire({ icon: "success", title: message });
export const showErrorToast = (message) => baseToast.fire({ icon: "error", title: message });
export const showInfoToast = (message) => baseToast.fire({ icon: "info", title: message });
export const showWarningToast = (message) => baseToast.fire({ icon: "warning", title: message });
